import { render, staticRenderFns } from "./DFCorrection.vue?vue&type=template&id=68feea26&scoped=true"
import script from "./DFCorrection.vue?vue&type=script&lang=js"
export * from "./DFCorrection.vue?vue&type=script&lang=js"
import style0 from "./DFCorrection.vue?vue&type=style&index=0&id=68feea26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68feea26",
  null
  
)

export default component.exports